// extracted by mini-css-extract-plugin
export var actions = "_mm-g";
export var benefitCard = "_mm-b";
export var benefitIcon = "_mm-d";
export var benefitLabel = "_mm-f";
export var benefits = "_mm-a";
export var benefitsSection = "_mm-8";
export var bodyText = "_mm-7";
export var closeButton = "_mm-2";
export var content = "_mm-3";
export var eyebrow = "_mm-4";
export var heading = "_mm-5";
export var image = "_mm-i";
export var imagePanel = "_mm-h";
export var modal = "_mm-0";
export var offerCard = "_mm-c";
export var offerIcon = "_mm-e";
export var sectionLabel = "_mm-9";
export var shell = "_mm-1";
export var title = "_mm-6";